"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Milestone = void 0;
var common_1 = require("../../schemas/common");
var milestone_1 = require("../../schemas/milestone");
var common_2 = require("../common");
var ChanceCase = require("change-case");
var Milestone = /** @class */ (function (_super) {
    __extends(Milestone, _super);
    function Milestone() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Milestone.defaultProps = function (name) {
        return {
            id: ChanceCase.constantCase(name),
            period: milestone_1.MilestonePeriod.UNKNOWN,
            staged: false,
            name: name,
            description: '',
            img: '',
            timeline: {
                min: 0,
                max: 0,
                unit: 'days'
            },
            duration: {
                min: 3,
                max: 4,
                unit: 'weeks'
            },
            severity: common_1.Severity.MINOR,
            category: milestone_1.MilestoneType.UNKNOWN,
            // children: [],
            dependencies: [],
            suggestionCriteria: null,
            step: null,
            valid: true,
            weights: [],
            additional: [],
            sources: [],
            recurring: null,
            checklist: []
        };
    };
    Milestone.firebaseTable = 'scout9-milestones';
    return Milestone;
}(common_2.AbstractModel));
exports.Milestone = Milestone;
